"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.ecSignatureParameterSchema = {
    id: '/ECSignatureParameter',
    type: 'string',
    pattern: '^0[xX][0-9A-Fa-f]{64}$',
};
exports.ecSignatureSchema = {
    id: '/ECSignature',
    properties: {
        v: {
            type: 'number',
            minimum: 27,
            maximum: 28,
        },
        r: { $ref: '/ECSignatureParameter' },
        s: { $ref: '/ECSignatureParameter' },
    },
    required: ['v', 'r', 's'],
    type: 'object',
};
//# sourceMappingURL=ec_signature_schema.js.map